import {
  Flex,
  Box,
  Image,
  Text,
  HStack,
  Button,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  SkeletonText,
} from "@chakra-ui/react";
import { brandPalette } from "../../../constants/brandPalette";
import { Link, useLocation } from "react-router-dom";
import React from "react";
import Logo from "../../../assets/logo.png";
import student from "../../../assets/icons/student.svg";
import groups from "../../../assets/icons/groups.svg";
import list from "../../../assets/icons/list.svg";
import videos from "../../../assets/icons/videos.svg";
import events from "../../../assets/icons/events.svg";
import exams from "../../../assets/icons/exams.svg";
import questions from "../../../assets/icons/questions.svg";
import payment from "../../../assets/icons/events.svg";
import { useDispatch, useSelector } from "react-redux";
import { RiFile2Fill, RiMegaphoneFill } from "react-icons/ri";
import { RiLogoutBoxRLine, RiSettings4Line } from "react-icons/ri";
import { FaUserCircle } from "react-icons/fa";
import { logoutUserAction } from "../../../modules/auth/Actions";
import AdminNotificationsBell from "../Notifications/AdminNotificationsBell";
const SuperAdminSidenavbar = ({ embedded = false }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);
  const location = useLocation();

  const palette = {
    primary: brandPalette.primary,
    secondary: brandPalette.secondary,
    tertiary: brandPalette.stone,
    neutralText: "rgba(247, 242, 236, 0.86)",
  };

  let navTabs = [
    { label: "Students", link: "/dashboard/students", icon: student },
    { label: "Groups", link: "/dashboard/groups", icon: groups },
    { label: "Centers", link: "/dashboard/lectures", icon: events },
    { label: "Content", link: "/dashboard/lessons", icon: list },
    { label: "Student Exams", link: "/dashboard/student-exams", icon: exams },
    {
      label: "Main Student Exams",
      link: "/dashboard/student_exams_main",
      icon: exams,
    },
    { label: "Videos", link: "/dashboard/videos", icon: videos },
    { label: "Views", link: "/super-admin/dashboard/views", icon: videos },
    { label: "Events", link: "/dashboard/events", icon: events },
    { label: "Chapters", link: "/dashboard/chapters", icon: list },
    { label: "Exams", link: "/dashboard/exams", icon: exams },
    {
      label: "Question Bank",
      link: "/dashboard/questions-bank",
      icon: questions,
    },
    {
      label: "Exam Redo Requests",
      link: "/dashboard/exam-redo-requests",
      icon: questions,
    },
  ];

  const sections = [
    {
      title: "Super Admin",
      items: navTabs,
    },
  ];
  return (
    <Flex
      as="aside"
      dir="ltr"
      position={embedded ? "relative" : "fixed"}
      left={embedded ? undefined : "0"}
      top={embedded ? undefined : "0"}
      h={embedded ? "100%" : "100vh"}
      minH={embedded ? "min(100vh, 720px)" : undefined}
      w={embedded ? "100%" : "260px"}
      maxW={embedded ? "100%" : undefined}
      bg={palette.primary}
      borderRight="1px solid"
      borderColor={palette.tertiary}
      flexDirection="column"
      zIndex={embedded ? 1 : "40"}
      overflow="hidden"
    >
      <Box px={6} py={8}>
        <Image
          src={Logo}
          alt="asquera"
          w="140px"
          h="auto"
          cursor="pointer"
          onClick={() => window.location.replace("/")}
          mx="auto"
        />
        <Text
          fontSize="10px"
          color="rgba(255,255,255,0.6)"
          letterSpacing="0.18em"
          textTransform="uppercase"
          mt={4}
          textAlign="center"
        >
          Admin System
        </Text>
      </Box>

      {isLoading ? (
        <HStack w="100%" bg="transparent" h="100%">
          <SkeletonText
            startColor="gray.100"
            endColor="gray.600"
            w="80%"
            mt="4"
            noOfLines={7}
            spacing="20"
          />
        </HStack>
      ) : (
        <Box
          flex="1"
          overflowY="auto"
          px={4}
          pb={8}
          className="scroll"
          sx={{
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {sections.map((section) => (
            <Box key={section.title} mb={6}>
              <Text
                px={2}
                mb={2}
                fontSize="xs"
                color="rgba(255,255,255,0.5)"
                textTransform="uppercase"
                letterSpacing="0.22em"
                fontWeight="700"
                textAlign="left"
              >
                {section.title}
              </Text>
              <Box>
                {section.items.map((item) => {
                  const active = location.pathname === item.link;
                  const isIconAsset = typeof item.icon === "string";
                  const IconCmp = isIconAsset ? null : item.icon;

                  return (
                    <Link key={item.link} to={item.link} style={{ textDecoration: "none" }}>
                      <Flex
                        align="center"
                        justify="flex-start"
                        gap={3}
                        px={3}
                        py={2}
                        bg={active ? palette.secondary : "transparent"}
                        color={active ? "white" : palette.neutralText}
                        borderLeft={active ? "4px solid" : "4px solid transparent"}
                        borderColor={active ? palette.tertiary : "transparent"}
                        borderRadius="14px"
                        transition="all 150ms ease"
                        _hover={{
                          bg: active ? palette.secondary : "rgba(69, 11, 17, 0.5)",
                          color: "white",
                        }}
                        fontSize="sm"
                        fontWeight="600"
                      >
                        {isIconAsset ? (
                          <Image
                            src={item.icon}
                            w="18px"
                            h="18px"
                            alt=""
                            filter="brightness(0) invert(1)"
                            opacity={active ? 1 : 0.85}
                          />
                        ) : (
                          <Box as={IconCmp} fontSize="18px" />
                        )}
                        <Text flex="1" textAlign="left">
                          {item.label}
                        </Text>
                      </Flex>
                    </Link>
                  );
                })}
              </Box>
            </Box>
          ))}
        </Box>
      )}

      <Flex
        p={4}
        bg={palette.secondary}
        align="center"
        gap={3}
        justify="space-between"
      >
        <Flex align="center" gap={3} minW={0} flex="1">
          <Flex
            w="40px"
            h="40px"
            flexShrink={0}
            bg={palette.primary}
            border="1px solid"
            borderColor={palette.tertiary}
            align="center"
            justify="center"
            borderRadius="12px"
          >
            <Box as={FaUserCircle} color="white" fontSize="20px" />
          </Flex>
          <Box overflow="hidden">
            <Text color="white" fontSize="sm" fontWeight="700" noOfLines={1}>
              Admin Profile
            </Text>
          </Box>
        </Flex>

        <AdminNotificationsBell />
        <Popover placement="top-end" closeOnBlur>
          <PopoverTrigger>
            <IconButton
              aria-label="Account settings"
              icon={<RiSettings4Line size={22} />}
              variant="ghost"
              color="white"
              flexShrink={0}
              borderRadius="12px"
              _hover={{ bg: "rgba(255,255,255,0.12)" }}
              _active={{ bg: "rgba(255,255,255,0.18)" }}
            />
          </PopoverTrigger>
          <PopoverContent
            w="220px"
            border="1px solid"
            borderColor={palette.tertiary}
            bg={brandPalette.cream}
            boxShadow="lg"
            _focus={{ outline: "none" }}
          >
            <PopoverArrow bg={brandPalette.cream} borderColor={palette.tertiary} />
            <PopoverBody p={3}>
              <Button
                w="100%"
                justifyContent="flex-start"
                leftIcon={<RiLogoutBoxRLine size={20} />}
                bg={palette.primary}
                color="white"
                size="sm"
                fontWeight="700"
                borderRadius="lg"
                _hover={{ bg: palette.secondary }}
                onClick={() => dispatch(logoutUserAction())}
              >
                Log out
              </Button>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Flex>
    </Flex>
  );
};

export default SuperAdminSidenavbar;
